import React from "react";
import styles from "../CreateParameterPopup.module.css";
import { ReactComponent as WhiteXCloseIcon } from "../../../assets/WhiteXCloseIcon.svg";
import { ReactComponent as PencilEdit } from "../../../assets/pencilEdit.svg";
import LabelParameters from "../LabelParameters";
import Button from "../../Button/Button";
import { useTranslation } from "react-i18next";
import DeleteButton from "../../DeleteButton/DeleteButton";
import CustomDropdown from "../../CustomDropdown/CustomDropdown";

const Tag = ({
  parameterData,
  setParameterData,
  handleChange,
  editingInput,
  setEditingInput,
  setShowAddTags,
}) => {
  const [t] = useTranslation("Contacts");
  
  function lightenHexColor(hex, percent) {
    // Elimina el "#" si existe
    hex = hex.replace(/^#/, "");
  
    // Si es shorthand (#abc), lo expandimos a #aabbcc
    if (hex.length === 3) {
      hex = hex.split("").map((c) => c + c).join("");
    }
  
    const num = parseInt(hex, 16);
  
    let r = (num >> 16) & 255;
    let g = (num >> 8) & 255;
    let b = num & 255;
  
    const lighten = (c) =>
      Math.min(255, Math.floor(c + (255 - c) * (percent / 100)));
  
    r = lighten(r);
    g = lighten(g);
    b = lighten(b);
  
    return `rgb(${r}, ${g}, ${b})`;
  }
  

  

  return (
    <div>
      <LabelParameters
        text="colors"
        editingInput={editingInput}
        setEditingInput={setEditingInput}
        checkEditingValidation={false}
      >
        <Button
          action={() => {
            setShowAddTags(true);
          }}
          type="white"
          headerStyle={{ borderRadius: "999px" }}
        >
          {t("addTag")}
        </Button>
      </LabelParameters>
  <div className={styles.dropdownContainer}>
<div>
<CustomDropdown
            editable={true}
            editing={true}
            options={
                parameterData?.selectedtags?.map(tag => tag.name) || []
              }              
            selectedOption={parameterData?.selectedOptionTag}
            setSelectedOption={(option) =>
              handleChange({ name: "selectedOptionTag", newValue: option })
            }
            // father={"automate"}
          />
</div>
  </div>
      <div className={styles.tagsContainer}>
        {parameterData?.selectedtags?.map((tag) => (
          <div className={styles.tag}>
          <div className={styles.taContent}>
          <span style={{ backgroundColor: lightenHexColor(tag.color, 60) }}>
                <div  style={{
                background: tag.color,
              }} className={styles.circle}></div>
              {tag.name}
            </span>
          </div>
        <div className={styles.actionsTag}>
        <Button type="border"><PencilEdit/></Button>
            <DeleteButton
              action={() =>
                setSelectedTags((prevSelected) =>
                  prevSelected.filter((tags) => tags.id !== tag.id)
                )
              }
              type={"black"}
              CustonIcon={WhiteXCloseIcon}
              customIconStyles={{
                height: "30px",
                minWidth: "30px",
                background: "#6E6E80",
              }}
            />

        </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tag;
